module.exports = __webpack_public_path__ + "media/landing/slider-7-06fafeae.jpeg";